import { createContext, useContext, RefObject } from 'react'

type AnnotationsContextType = {
  annotationsCanvasRef: RefObject<HTMLDivElement | null> | null
  floatingOverlayElement: HTMLDivElement | null
  setIsResizing: (isResizing: boolean) => void
}

export const AnnotationsContext = createContext<AnnotationsContextType>({
  annotationsCanvasRef: null,
  floatingOverlayElement: null,
  setIsResizing: () => {},
})

export const useAnnotationsContext = () => useContext(AnnotationsContext)

export const AnnotationsProvider = ({
  children,
  annotationsCanvasRef,
  floatingOverlayElement,
  setIsResizing,
}: {
  children: React.ReactNode
  annotationsCanvasRef: RefObject<HTMLDivElement | null>
  floatingOverlayElement: HTMLDivElement | null
  setIsResizing: (isResizing: boolean) => void
}) => {
  return (
    <AnnotationsContext.Provider
      value={{
        setIsResizing,
        annotationsCanvasRef,
        floatingOverlayElement,
      }}
    >
      {children}
    </AnnotationsContext.Provider>
  )
}
